import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Button, Popconfirm, Icon } from 'antd'
import { VideoView } from '../assets-view/VideoView'
import DocumentView from '../document-view/DocumentView'
import { deleteSelectedAsset } from '../../actions/ClientAction'
import { setkeyboardEnabled } from '../../actions/AppAction'
import './delete-asset.css'
import fileextension from 'file-extension'
import SVGView from '../assets-view/SVGView'


export class DeleteAsset extends Component {
  constructor(props) {
    super(props)

    this.state = {
      breadCrumbs: []
    }
  }

  componentDidMount() {
    this.handleGetPathItem()
    this.props.setkeyboardEnabled(true)

  }

  handleDeleteAsset = () => {
    const { keyCollection, workclient, itemSelected, intl } = this.props
    this.props.deleteSelectedAsset(keyCollection, workclient, itemSelected._id, intl)
    this.props.setkeyboardEnabled(false)
  }

  handleGetPathItem = () => {
    const { itemSelected, breadcrumb } = this.props
    let route = []
    if (itemSelected.parents) {
      itemSelected.parents.forEach(itemParents => {
        breadcrumb.forEach(breadElement => {
          if (itemParents === breadElement._id)
            route.push(breadElement.name)
        });
      });
      this.setState({
        breadCrumbs: `/${route.join('/')}`
      })
    }
  }

  render() {
    const { breadCrumbs } = this.state
    const { itemSelected, handleHideDeleteDrawer, newColor, intl } = this.props;

    return (
      <React.Fragment>
        <div className='delete-drawer-content'>
          <div className='asset-view'>

            {
              itemSelected.type === 'image' && fileextension(itemSelected.originalURL) === 'svg'
              && <SVGView comFromMiddleView={true} src={itemSelected.originalURL} assetId={itemSelected._id} />
            }
            {
              itemSelected.type === 'image' && fileextension(itemSelected.originalURL) !== 'svg' &&
              <img
                alt={itemSelected.name}
                src={itemSelected.mediaQualityURL}
              />
            }
            {itemSelected.type === 'video' && <VideoView
              url={itemSelected.lowQualityURL}
              disableDefaultControls={false}
              autoPlay={false}
              muted={true}
            />}
            {itemSelected.type === 'document' && <DocumentView
              item={itemSelected}
              from={`middleView`} />}
          </div>
          <div data-show="true" className="ant-alert ant-alert-warning ant-alert-with-description" style={{ marginTop: 10 }}>
            <i aria-label="icon: exclamation-circle" className="anticon anticon-exclamation-circle ant-alert-icon">
              <svg viewBox="64 64 896 896" className="" data-icon="exclamation-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false">
                <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path>
                <path d="M464 688a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z"></path>
              </svg>
            </i>
            <span className="ant-alert-message">{intl.formatMessage({ id: "warning" })}</span>
            <span className="ant-alert-description">{intl.formatMessage({ id: "first_warning_delete" })} <b>{breadCrumbs}</b></span>
          </div>

          <div className='asset-title' style={{ paddingTop: 5, paddingBottom: 10 }}>
            <span>¿{intl.formatMessage({ id: "second_warning_delete" })} <b>{itemSelected.name}</b>?</span>
          </div>
          <div>
            <Button.Group >
              <Popconfirm
                title={intl.formatMessage({ id: "third_warning_delete" })}
                onConfirm={this.handleDeleteAsset}
                okText={intl.formatMessage({ id: "delete_asset" })}
                cancelText={intl.formatMessage({ id: "cancel_button" })}
              >
                <Button type="primary" style={{ backgroundColor: newColor, borderColor: newColor, marginRight: '10px' }} >{intl.formatMessage({ id: "delete_asset" })}</Button>
              </Popconfirm>
              <Button
                style={{ color: newColor, borderColor: newColor }}
                onClick={handleHideDeleteDrawer}
              >{intl.formatMessage({ id: "cancel_button" })}<Icon type="close" /></Button>
            </Button.Group>
          </div>
        </div >
      </React.Fragment >
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { keyCollection } = ownProps
  let object

  switch (keyCollection) {
    case 'assetsRoot':
      object = {
        isFetching: state.assetsRoot.isFetching,
        isUpdating: state.assetsLastUploads.isUpdating,
        data: state.assetsRoot.data,
        folderselect: state.assetsRoot.folderselect,
        error: state.assetsRoot.error,
        activeView: state.assetsRoot.activeView
      }
      break
    case 'assetsLastUploads':
      object = {
        isFetching: state.assetsLastUploads.isFetching,
        isUpdating: state.assetsLastUploads.isUpdating,
        data: state.assetsLastUploads.data,
        folderselect: state.assetsLastUploads.folderselect,
        error: state.assetsLastUploads.error,
        activeView: state.assetsLastUploads.activeView
      }
      break
    case 'assetsShared':
      object = {
        isFetching: state.assetsShared.isFetching,
        isUpdating: state.assetsLastUploads.isUpdating,
        data: state.assetsShared.data,
        folderselect: state.assetsShared.folderselect,
        error: state.assetsShared.error,
        activeView: state.assetsShared.activeView
      }
      break
    case 'assetsFavorites':
      object = {
        isFetching: state.assetsFavorites.isFetching,
        isUpdating: state.assetsLastUploads.isUpdating,
        data: state.assetsFavorites.data,
        folderselect: state.assetsFavorites.folderselect,
        error: state.assetsFavorites.error,
        activeView: state.assetsFavorites.activeView
      }
      break
    case 'assetsExplore':
      object = {
        isFetching: state.assetsExplore.isFetching,
        isUpdating: state.assetsLastUploads.isUpdating,
        data: state.assetsExplore.data,
        folderselect: state.assetsExplore.folderselect,
        error: state.assetsExplore.error,
        activeView: state.assetsExplore.activeView
      }
      break

    default:
      object = {}
      break
  }
  return {
    ...object,
    verticalCount: state.app.verticalCount,
    horizontalCount: state.app.horizontalCount,
    breadcrumb: state.client.breadcrumb,
    workclient: state.client.workclient,
    newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF'
  }
}

const mapDispatchToProps = {
  deleteSelectedAsset,
  setkeyboardEnabled
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(DeleteAsset)))